<template>
	<div class="option-selector-wrapper">
		<slot></slot>
	</div>
</template>
<style scoped lang="scss">
	.option-selector-wrapper {
		display: flex;
		gap: 20px;
	}

	.option-selector-wrapper :deep(> *) {
		width: 100%;
		max-width: 50%;
		position: relative;
	}
</style>
